<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="onTabChange(tab.id)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Tab 1: 8865 Schedule O -->
    @if (activeTab === 0) {
<div class="tab-pane active">
      <h3 class="text-center">
        <b>Form 8865 Schedule O: Transfer of Property to a Foreign Partnership (under section 6038B)</b>
      </h3>

      <!-- Loading Spinner -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- Content when not loading -->
      @if (!showFormLoader) {
<div class="tables-container">
        <!-- Part I: Transfers Reportable -->
        @if (isReportableTransferDataPresent) {
<div>
          <div class="text-center section-header" (click)="reportableTransferCollapsed = !reportableTransferCollapsed">
            <a style="color:#fff; cursor: pointer;">
              Part I: Transfers Reportable Under Section 6038B (All amounts in U.S. Dollars)
            </a>
          </div>
          <br>

          @if (reportableTransferCollapsed) {
<div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th rowspan="2">Partner Details</th>
                  <th rowspan="2">Type of property</th>
                  <th rowspan="2">Date of Transfer (mm/dd/yyyy)</th>
                  <th rowspan="2">Number of items transferred</th>
                  <th rowspan="2">Fair market value on date of transfer</th>
                  <th rowspan="2">Cost or other basis</th>
                  <th rowspan="2">Section 704(c) allocation method</th>
                  <th rowspan="2">Gain recognized on transfer</th>
                  <th rowspan="2">Percentage interest in partnership after transfer</th>
                  <th rowspan="2">Transfer Subject to Gain Recog.?</th>
                  <th rowspan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (item of transferObj; track $index) {
<tr>
                  <td>{{item.PARTNER_DETAILS}}</td>
                  <td>{{item.TYPE_OF_PROPERTY}}</td>
                  <td>{{item.DATE_OF_TRANSFER | date:'MM/dd/yyyy'}}</td>
                  <td style="text-align: right">{{item.NUMBER_OF_ITEMS_TRANSFERRED | number}}</td>
                  <td style="text-align: right">{{item.FAIR_MARKET_VALUE | number}}</td>
                  <td style="text-align: right">{{item.COST_OR_OTHER_BASIS | number}}</td>
                  <td>{{item.ALLOCATION_METHOD}}</td>
                  <td style="text-align: right">{{item.GAIN_RECOGNIZED_ON_TRANSFER | number}}</td>
                  <td style="text-align: right">{{item.PERCENTAGE_INTEREST}}</td>
                  <td>{{item.SUBJECT_TO_GAIN_RECOGNITION}}</td>
                  <td>
                    <button class="action-button edit-button" type="button" (click)="edit8865ScheduleO(item)">
                      Edit
                    </button>
                    <button class="action-button delete-button" type="button" (click)="deleteSchedule(item)">
                      Delete
                    </button>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
}
        </div>
}

        <!-- Part II: Dispositions Reportable -->
        @if (isReportableDispositionDataPresent) {
<div>
          <div class="text-center section-header" (click)="requestDispositionCollapsed = !requestDispositionCollapsed">
            <a style="color:#fff; cursor: pointer;">
              Part II: Dispositions Reportable Under Section 6038B (All amounts in U.S. Dollars)
            </a>
          </div>
          <br>

          @if (requestDispositionCollapsed) {
<div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th rowspan="2">Partner Details</th>
                  <th rowspan="2">Type of property</th>
                  <th rowspan="2">Date of Transfer (mm/dd/yyyy)</th>
                  <th rowspan="2">Date of disposition(mm/dd/yyyy)</th>
                  <th rowspan="2">Manner of disposition</th>
                  <th rowspan="2">Gain recognized by partnership</th>
                  <th rowspan="2">Depreciation recapture recognized by partnership</th>
                  <th rowspan="2">Gain allocated to partner</th>
                  <th rowspan="2">Depreciation recapture allocated to partner</th>
                  <th rowspan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (item of dispositionObj; track $index) {
<tr>
                  <td>{{item.PARTNER_DETAILS}}</td>
                  <td>{{item.TYPE_OF_PROPERTY}}</td>
                  <td>{{item.DATE_OF_ORIGINAL_TRANSFER | date:'MM/dd/yyyy'}}</td>
                  <td>{{item.DATE_OF_DISPOSITION | date:'MM/dd/yyyy'}}</td>
                  <td>{{item.MANNER_OF_DISPOSITION}}</td>
                  <td style="text-align: right">{{item.GAIN_RECOGNIZED_BY_PARTNERSHIP | number}}</td>
                  <td style="text-align: right">{{item.DEPRECIATION_RECAPTURE_RECOGNIZED | number}}</td>
                  <td style="text-align: right">{{item.GAIN_ALLOCATED_TO_PARTNER | number}}</td>
                  <td style="text-align: right">{{item.DEPRECIATION_RECAPTURE_ALLOCATED | number}}</td>
                  <td>
                    <button class="action-button edit-button" type="button" (click)="edit8865ScheduleO(item)">
                      Edit
                    </button>
                    <button class="action-button delete-button" type="button" (click)="deleteSchedule(item)">
                      Delete
                    </button>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
}
        </div>
}

        <!-- Supplemental Information -->
        @if (isSupplementalInformationPresent) {
<div>
          <div class="text-center section-header" (click)="supplementalInformationCollapsed = !supplementalInformationCollapsed">
            <a style="color:#fff; cursor: pointer;">
              Supplemental Information Required To Be Reported (see instructions for Part I)
            </a>
          </div>
          <br>

          @if (supplementalInformationCollapsed) {
<div>
            <div>
              <span>Enter any information required to be reported in Part I in greater detail. Identify the applicable column number next to the information entered in this section.<br>
              In addition, if you contributed property to a foreign partnership as part of a wider transaction, briefly describe the entire transaction.</span>
            </div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th>Supplemental Information</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @for (item of supplementalObj; track $index) {
<tr>
                  <td>{{item.SUPPLEMENTAL_INFORMATION}}</td>
                  <td>
                    <button class="action-button edit-button" type="button" (click)="edit8865ScheduleO(item)">
                      Edit
                    </button>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
}
        </div>
}
      </div>
}
    </div>
}

    <!-- Tab 2: Add new Reportable Transfer -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div>
        <h3 class="text-center">
          <b>Form 8865 Schedule O: Transfers Reportable under section 6038B</b>
        </h3>
        <div>
          <h4>
            <i class="fa fa-info-circle"></i>
            All amounts in U. S. Dollars
          </h4>
        </div>

        <!-- Partner Details -->
        <div class="form-group row">
          <label class="col-md-6">Partner Details:</label>
          <div class="col-md-6">
            <select 
              name="partnerTransfer" 
              [(ngModel)]="selectedPartOneData.PARTNER_DETAILS" 
              (ngModelChange)="validateForm($event, 1, 'PARTNER_DETAILS')" 
              class="form-control">
              @for (partner of partnerDetails; track $index) {
<option [ngValue]="partner">
                {{partner.PARTNER_DESC}}
              </option>
}
            </select>
            @if (partnerDetailsFlag) {
<span class="form-error-container">Partner Details is a required field.</span>
}
          </div>
        </div>

        <!-- Type of Property -->
        <div class="form-group row">
          <label class="col-md-6">Type of Property:</label>
          <div class="col-md-6">
            <select 
              name="propertyTransfer" 
              [(ngModel)]="selectedPartOneData.TYPE_OF_PROPERTY" 
              (ngModelChange)="validateForm($event, 1, 'TYPE_OF_PROPERTY')" 
              class="form-control">
              @for (property of typeOfProperty; track $index) {
<option [ngValue]="property">
                {{property.PROP_DESC}}
              </option>
}
            </select>
            @if (typeOfPropertyFlag) {
<span class="form-error-container">Type of Property is a required field.</span>
}
          </div>
        </div>

        <!-- Date of Transfer -->
        <div class="form-group row">
          <label class="col-md-6">Date of Transfer (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input 
              type="date" 
              class="form-control" 
              [(ngModel)]="selectedPartOneData.DATE_OF_TRANSFER"
              (ngModelChange)="formatDate(1)">
            @if (date_flag_transfer) {
<span class="form-error-container">Date of Transfer is required</span>
}
            @if (date_range_transfer) {
<span class="form-error-container">
              You can only enter date between {{rowData.TAX_YEAR_BEGIN | date:'MM/dd/yyyy'}} to {{rowData.TAX_YEAR_END | date:'MM/dd/yyyy'}}
            </span>
}
          </div>
        </div>

        <!-- Number of items transferred -->
        <div class="form-group row">
          <label class="col-md-6">Number of items transferred:</label>
          <div class="col-md-6">
            <input 
              name="itemsTransferred" 
              style="text-align: right" 
              type="text" 
              onlyIntegersWithLength
              [(ngModel)]="selectedPartOneData.NUMBER_OF_ITEMS_TRANSFERRED" 
              [disabled]="selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE == '1'"
              (ngModelChange)="validateForm($event, 1, 'NUMBER_OF_ITEMS_TRANSFERRED')"
              class="form-control" 
              placeholder="0">
            @if (numberOfItemTransferredFlag && selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE !== '1') {
<span class="form-error-container">
              Number of items transferred is a required field.
            </span>
}
          </div>
        </div>

        <!-- Fair Market value -->
        <div class="form-group row">
          <label class="col-md-6">Fair Market value on date of transfer:</label>
          <div class="col-md-6">
            <input 
              name="fairMarket" 
              style="text-align: right" 
              type="text" 
              onlyDigitsDecimal
              [(ngModel)]="selectedPartOneData.FAIR_MARKET_VALUE" 
              class="form-control" 
              placeholder="0">
          </div>
        </div>

        <!-- Cost or other basis -->
        <div class="form-group row">
          <label class="col-md-6">Cost or other basis:</label>
          <div class="col-md-6">
            <input 
              name="costBasis" 
              style="text-align: right" 
              type="text" 
              onlyDigitsDecimal
              [(ngModel)]="selectedPartOneData.COST_OR_OTHER_BASIS" 
              [disabled]="selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE == '1'"
              class="form-control" 
              placeholder="0">
          </div>
        </div>

        <!-- Sec. 704(c) allocation method -->
        <div class="form-group row">
          <label class="col-md-6">Sec. 704(c) allocation method:</label>
          <div class="col-md-6">
            <select 
              name="allocationMethod" 
              [(ngModel)]="selectedPartOneData.ALLOCATION_METHOD" 
              (ngModelChange)="validateForm($event, 1, 'ALLOCATION_METHOD')"
              [disabled]="selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE == '1'"
              class="form-control">
              @for (method of allocationMethod; track $index) {
<option [ngValue]="method">
                {{method.PROP_DESC}}
              </option>
}
            </select>
            @if (secAllocationMethodFlag && selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE != '1') {
<span class="form-error-container">
              Sec. 704(c) allocation method is a required field.
            </span>
}
            @if (selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE !== '1' && selectedPartOneData.ALLOCATION_METHOD?.PROP_TYPE =='0') {
<span class="form-error-container">
              Sec. 704(c) allocation method cannot be None.
            </span>
}
          </div>
        </div>

        <!-- Gain recognized on transfer -->
        <div class="form-group row">
          <label class="col-md-6">Gain recognized on transfer:</label>
          <div class="col-md-6">
            <input 
              type="text" 
              style="text-align: right" 
              name="gainRecognized" 
              onlyDigitsDecimal
              [(ngModel)]="selectedPartOneData.GAIN_RECOGNIZED_ON_TRANSFER" 
              [disabled]="selectedPartOneData.TYPE_OF_PROPERTY?.PROP_TYPE === '1'"
              class="form-control" 
              placeholder="0">
          </div>
        </div>

        <!-- Percentage interest -->
        <div class="form-group row">
          <label class="col-md-6">Percentage interest in partnership after transfer:</label>
          <div class="col-md-6">
            <input 
              name="percentOfInterest" 
              type="text" 
              style="text-align: right" 
              [(ngModel)]="selectedPartOneData.PERCENTAGE_INTEREST" 
              maxlength="9" 
              pattern="^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$"
              class="form-control" 
              placeholder="0">
            @if (percentageInterestFlag) {
<span class="form-error-container">
              Percentage interest must be between 0 and 100.
            </span>
}
          </div>
        </div>

        <!-- Transfer Subject to Gain Recognition -->
        <div class="form-group row">
          <label class="col-md-6">Is the Transfer Subject to Gain Recognition?</label>
          <div class="col-md-6">
            <select 
              name="gainRecognition" 
              [(ngModel)]="selectedPartOneData.SUBJECT_TO_GAIN_RECOGNITION" 
              (ngModelChange)="validateForm($event, 1, 'SUBJECT_TO_GAIN_RECOGNITION')"
              class="form-control">
              @for (gain of gainRecognition; track $index) {
<option [ngValue]="gain">
                {{gain.PROP_DESC}}
              </option>
}
            </select>
            @if (selectedPartOneData.SUBJECT_TO_GAIN_RECOGNITION?.PROP_TYPE=='NA' || gainRecognitionFlag) {
<span class="form-error-container">
              Transfer Subject to Gain Recognition is a required field.
            </span>
}
          </div>
        </div>
      </div>
    </div>
}

    <!-- Tab 3: Add new Reportable Disposition -->
    @if (activeTab === 2) {
<div class="tab-pane active">
      <div>
        <h3 class="text-center">
          <b>Form 8865 Schedule O: Dispositions Reportable under section 6038B</b>
        </h3>
        <div>
          <h4>
            <i class="fa fa-info-circle"></i>
            All amounts in U. S. Dollars
          </h4>
        </div>

        <!-- Partner Details -->
        <div class="form-group row">
          <label class="col-md-6">Partner Details:</label>
          <div class="col-md-6">
            <select name="partnerDisposition" 
                    [(ngModel)]="selectedPartTwoData.PARTNER_DETAILS" 
                    class="form-control"
                    (change)="validateForm(selectedPartTwoData.PARTNER_DETAILS?.PARTNER_CODE, 2, 'PARTNER_DETAILS.PARTNER_CODE')">
              @for (partner of partnerDetails; track $index) {
<option [ngValue]="partner">
                {{ partner.PARTNER_DESC }}
              </option>
}
            </select>
            @if (partnerDetailsFlag1) {
<span class="form-error-container">
              Partner Details is a required field.
            </span>
}
          </div>
        </div>

        <!-- Type of Property -->
        <div class="form-group row">
          <label class="col-md-6">Type of Property:</label>
          <div class="col-md-6">
            <select name="propertyDisposition" 
                    [(ngModel)]="selectedPartTwoData.TYPE_OF_PROPERTY" 
                    class="form-control"
                    (change)="validateForm(selectedPartTwoData.TYPE_OF_PROPERTY?.PROP_TYPE, 2, 'TYPE_OF_PROPERTY')">
              @for (property of typeOfProperty; track $index) {
<option [ngValue]="property">
                {{ property.PROP_DESC }}
              </option>
}
            </select>
            @if (typeOfPropertyFlag1) {
<span class="form-error-container">
              Type of Property is a required field.
            </span>
}
          </div>
        </div>

        <!-- Date of Original Transfer -->
        <div class="form-group row">
          <label class="col-md-6">Date of Original Transfer (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input type="date" 
                   class="form-control" 
                   [(ngModel)]="selectedPartTwoData.DATE_OF_ORIGINAL_TRANSFER" />
          </div>
        </div>

        <!-- Date of Disposition -->
        <div class="form-group row">
          <label class="col-md-6">Date of Disposition (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input type="date" 
                   class="form-control" 
                   [(ngModel)]="selectedPartTwoData.DATE_OF_DISPOSITION"
                   (ngModelChange)="formatDate(2)" />
            @if (date_flag_disposition) {
<span class="form-error-container">
              Date of Disposition is required
            </span>
}
            @if (date_range_disposition) {
<span class="form-error-container">
              You can only enter date between {{ rowData.TAX_YEAR_BEGIN | date : 'MM/dd/yyyy' }} to {{ rowData.TAX_YEAR_END | date : 'MM/dd/yyyy' }}
            </span>
}
          </div>
        </div>

        <!-- Manner of Disposition -->
        <div class="form-group row">
          <label class="col-md-6">Manner of Disposition:</label>
          <div class="col-md-6">
            <select name="disposition" 
                    [(ngModel)]="selectedPartTwoData.MANNER_OF_DISPOSITION"
                    class="form-control"
                    (change)="validateForm(selectedPartTwoData.MANNER_OF_DISPOSITION?.PROP_TYPE, 2, 'MANNER_OF_DISPOSITION.PROP_TYPE')">
              @for (disposition of mannerOfDisposition; track $index) {
<option [ngValue]="disposition">
                {{ disposition.PROP_DESC }}
              </option>
}
            </select>
            @if (selectedPartTwoData.MANNER_OF_DISPOSITION?.PROP_TYPE === '0') {
<span class="form-error-container">
              Manner of Disposition cannot be none.
            </span>
}
          </div>
        </div>

        <!-- Gain recognized by partnership -->
        <div class="form-group row">
          <label class="col-md-6">Gain recognized by partnership:</label>
          <div class="col-md-6">
            <input type="text" 
                   onlyDigitsDecimal
                   [(ngModel)]="selectedPartTwoData.GAIN_RECOGNIZED_BY_PARTNERSHIP"
                   class="form-control" 
                   placeholder="0"
                   style="text-align: right" />
          </div>
        </div>

        <!-- Depreciation recapture recognized by partnership -->
        <div class="form-group row">
          <label class="col-md-6">Depreciation recapture recognized by partnership:</label>
          <div class="col-md-6">
            <input type="text" 
                   onlyDigitsDecimal
                   [(ngModel)]="selectedPartTwoData.DEPRECIATION_RECAPTURE_RECOGNIZED"
                   class="form-control" 
                   placeholder="0"
                   style="text-align: right" />
          </div>
        </div>

        <!-- Gain allocated to partner -->
        <div class="form-group row">
          <label class="col-md-6">Gain allocated to partner:</label>
          <div class="col-md-6">
            <input type="text" 
                   onlyDigitsDecimal
                   [(ngModel)]="selectedPartTwoData.GAIN_ALLOCATED_TO_PARTNER"
                   class="form-control" 
                   placeholder="0"
                   style="text-align: right" />
          </div>
        </div>

        <!-- Depreciation recapture allocated to partner -->
        <div class="form-group row">
          <label class="col-md-6">Depreciation recapture allocated to partner:</label>
          <div class="col-md-6">
            <input type="text" 
                   onlyDigitsDecimal
                   [(ngModel)]="selectedPartTwoData.DEPRECIATION_RECAPTURE_ALLOCATED"
                   class="form-control" 
                   placeholder="0"
                   style="text-align: right" />
          </div>
        </div>
      </div>
    </div>
}

    <!-- Tab 4: Add new Supplemental Information -->
    @if (activeTab === 3) {
<div class="tab-pane active">
      <div>
        <h3 class="text-center">
          <b>Form 8865 Schedule O: Supplemental Information Required To Be Reported</b>
        </h3>
        <div>
          <h4>
            <i class="fa fa-info-circle"></i>
            Enter any information required to be reported in Part I in greater detail. Identify the applicable column number next to the information entered in this section.<br>
            In addition, if you contributed property to a foreign partnership as part of a wider transaction, briefly describe the entire transaction.<br>
          </h4>
        </div>

        <!-- Partner Details -->
        <div class="form-group row">
          <label class="col-md-6">Partner Details:</label>
          <div class="col-md-6">
            <select name="partner" 
                    [(ngModel)]="selectedSuppleInfoData.PARTNER_DETAILS"
                    (change)="validateForm(selectedSuppleInfoData.PARTNER_DETAILS?.PARTNER_CODE, 3, 'PARTNER_DETAILS')"
                    class="form-control">
              @for (partner of partnerDetails; track $index) {
<option [ngValue]="partner">
                {{ partner.PARTNER_DESC }}
              </option>
}
            </select>
            @if (partnerDetailsFlag2) {
<span class="form-error-container">
              Partner Details is a required field. Please re-enter and try again.
            </span>
}
          </div>
        </div>

        <!-- Supplemental Information -->
        <div class="form-group row">
          <label class="col-md-6">Supplemental Information:</label>
          <div class="col-md-6">
            <textarea 
              name="supplementalInfo"
              [(ngModel)]="selectedSuppleInfoData.SUPPLEMENTAL_INFORMATION"
              class="form-control"
              maxlength="4000"
              rows="6"
              placeholder="Enter supplemental information (max 4000 characters)"></textarea>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer (Only Cancel button for Tab 0) -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != '8865 Schedule O') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != '8865 Schedule O') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

